import React from "react"
import { videoContainer } from "./video.module.css"
import YouTubePlayer from "../../youtube-player/youtube-player"

function extractYouTubeID(url) {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  var match = url.match(regExp)
  if (match && match[7].length === 11) {
    return match[7]
  } else {
    return
  }
}

function extractVimeoID(url) {
  var regExp =
    /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
  var match = url.match(regExp)
  return match && match[5] ? match[5] : false
}

const Video = ({ data }) => {
  if (!data || !data.url) return <></>

  const url = data.url
  if (url.includes("vimeo.com/")) {
    const vimeoId = extractVimeoID(url)
    if (!vimeoId) return <></>
    return (
      <span className={videoContainer}>
        <iframe
          loading="lazy"
          title="Vimeo"
          width="853"
          height="480"
          src={`https://player.vimeo.com/video/${vimeoId}`}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </span>
    )
  } else if (url.includes("youtube.com") || url.includes("youtu.be")) {
    const youtubeId = extractYouTubeID(url)
    if (!youtubeId) return <></>

    return (
      <div
        style={{
          display: "block",
          position: "relative",
          paddingBottom: "56.25%",
          height: 0,
          overflow: "hidden",
          margin: "40px 0px",
        }}
      >
        <YouTubePlayer videoId={youtubeId} />
      </div>
    )

    // Old YoutubePlayer
    return (
      <span className={videoContainer}>
        <iframe
          id="player"
          loading="lazy"
          title="YouTube"
          width="853"
          height="480"
          src={"https://www.youtube.com/embed/" + youtubeId + "?enablejsapi=1"}
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </span>
    )
  } else {
    return <></>
  }
}

export default Video
